// extracted by css-extract-rspack-plugin
export default {"ConnectedBankAccount-icon":"sputnik__ConnectedBankAccount-icon__bmAum","connectedBankAccountIcon":"sputnik__ConnectedBankAccount-icon__bmAum"};